import * as React from 'react';
import HierarchicalDevicePicker from './HierarchicalDevicePicker';
import { AlgoliaDevicePicker } from './AlgoliaDevicePicker';
import type { DevicePickerProps, View } from './types';
import {
   useDevicePickerContext,
   withDevicePickerContext,
} from './DevicePickerContext';
export { View };

export const DevicePicker = withDevicePickerContext(DevicePickerComponent);

export function DevicePickerComponent(props: DevicePickerProps) {
   const algoliaConfig = props.algoliaConfig;
   const { state, setState, setQuery, setCategory } = useDevicePickerContext();

   if (algoliaConfig === undefined || state === 'category') {
      return (
         <HierarchicalDevicePicker
            onSearch={(value) => {
               setState('search');
               setQuery(value);
            }}
            {...props}
         />
      );
   }

   return (
      <AlgoliaDevicePicker
         onSelectCategory={(category) => {
            setState('category');
            setCategory(category);
            setQuery(category);
         }}
         algoliaConfig={algoliaConfig}
         {...props}
      />
   );
}
